// tslint:disable-next-line
import { createBrowserHistory } from 'history';

export default createBrowserHistory();
